import { get } from 'lodash-es';
import { AxiosResponse } from 'axios';
import { message as EeveeMessage } from '@fuxi/eevee-ui';
import { safeToLogin, handleLogout, isCanceledError } from 'common/utils';

// 不需要全局提示的错误
const noGlobalPromptCodes: number[] = [401];

export const zhongbaoErrorHandler = (error: any) => {
  // Ignore error when request is canceled by user:
  if (isCanceledError(error)) return;

  const status: number = get(error, 'response.status', 0);
  const code: number = get(error, 'response.data.code', 0);

  // http级别错误处理
  if (status === 401) {
    handleLogout();
    safeToLogin();
  } else if (noGlobalPromptCodes.length > 0 && !noGlobalPromptCodes.includes(code)) {
    const msg = get(error, 'response.data.message', '服务端异常');
    EeveeMessage.error(msg);
  }

  return Promise.reject(error);
};

export const zhongbaoResponseHandler = (
  response: AxiosResponse & { code?: number; message?: string },
): ExtendAxioResponse => {
  const data = get(response, 'data.data', response.data);
  const code = get(response, 'data.code', response?.code);
  const message = get(response, 'data.message', response?.message);
  //众包的code
  if (code === 2100 || code === 403) {
    EeveeMessage.error('登录过期，请重新登录');
    //用户token过期，需要重新登录
    handleLogout();
    safeToLogin();
  } else if (code === 401 || code === 1) {
    EeveeMessage.error('请先登录');
    //用户token过期，需要重新登录
    handleLogout();
    safeToLogin();
  }

  return { ...response, data, code, message };
};
